<template>
  <div>
    <batch-query v-show="action === 'query'" @change-action="changeAction" />
    <batch-import v-if="action === 'batch'" :batch-num="batchNum" @change-action="changeAction" />
  </div>
</template>

<script>
import BatchImport from './components/BatchImport.vue'
import BatchQuery from './components/BatchQuery.vue'
export default {
  components: {
    BatchImport,
    BatchQuery
  },
  data() {
    return {
      action: 'query',
      batchNum: ''
    }
  },
  methods: {
    changeAction(type, batchNum) {
      this.action = type
      this.batchNum = batchNum || ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanBatchImport.vue